module.exports = __webpack_public_path__ + "static/media/accessories-2.082594d6.jpg";